import React from 'react';
import { Constrain, Breakpoint, Clickable } from '@moda/om';
import LogoHorizontalIcon from '@moda/icons/logo-horizontal-189-x-12';
import {
  SiteFooterBasementCheckoutDesktop,
  SiteFooterBasementCheckoutMobile
} from './SiteFooterBasementCheckout';

import './SiteFooterCheckout.scss';

export const SiteFooterCheckout: React.FC = () => {
  return (
    <Constrain className="SiteFooterCheckout">
      <div className="SiteFooterCheckout__logo">
        <Clickable to="/" aria-label="Go to homepage">
          <LogoHorizontalIcon />
        </Clickable>
      </div>

      <Breakpoint gt="sm">
        <SiteFooterBasementCheckoutDesktop />
      </Breakpoint>

      <Breakpoint lt="sm">
        <SiteFooterBasementCheckoutMobile />
      </Breakpoint>
    </Constrain>
  );
};
